function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import isBlank from "@sedan-utils/is-blank";
import { message } from "../components/Message/Message";
export var NodesUtil = /*#__PURE__*/function () {
  function NodesUtil() {
    _classCallCheck(this, NodesUtil);
  }
  _createClass(NodesUtil, null, [{
    key: "hasProperty",
    value: function hasProperty(obj) {
      var hasProp = false;
      for (var prop in obj) {
        hasProp = true;
        break;
      }
      return hasProp;
    }
  }, {
    key: "isEmpty",
    value: function isEmpty(value) {
      return value == null || value == "" || typeof value === "string" && value.trim() == "" || _typeof(value) === "object" && !NodesUtil.hasProperty(value) || value instanceof Array && value.length == 0;
    }
  }, {
    key: "getLocation",
    value: function getLocation() {
      var notBlock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      return new Promise(function (resolve, reject) {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(function (position) {
            resolve({
              lat: position.coords.latitude,
              lng: position.coords.longitude
            });
          }, function (error) {
            console.log("get loacation error::", error);
            if (notBlock) {
              resolve(undefined);
            } else {
              reject(error);
            }
          });
        } else {
          console.log("can not get location");
        }
      });
    }
  }]);
  return NodesUtil;
}();
_defineProperty(NodesUtil, "constants", {
  NO_WHEEL: "nowheel",
  supportList: ["PDF", "XLSX", "CSV", "TXT", "DOC", "DOCX", "PNG", "JPG", "JPEG", "SVG", "MP4", "MP3", "M4A"]
});
_defineProperty(NodesUtil, "message", message);
_defineProperty(NodesUtil, "isBlank", isBlank);